export default __webpack_public_path__ + "static/media/ianCoates.715f0d78.JPG";